import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import pushToDataLayer from "../util/dataLayer.ts";

export default function useDatalayer() {
    const {pathname} = useLocation();

    useEffect(() => {
        fetch(`/datalayer`).then((r) => {
            r.json().then((j) => {
                pushToDataLayer(j)
            })
        })
    }, [pathname])
}
